import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { PipelineItem } from "@/features/adp/api/pipelineLists.api";

type OverlayType = "schedule-pipeline-modal" | "delete-pipeline-dialog" | null;

export interface SchedulePipelineOverlayData {
    pipelineName?: string | null;
    sessionId?: string | null;
    isSchedule?: boolean;
    scheduleDetails?: PipelineItem["schedule_details"];
    scheduleTypeName?: string | null;
}

export interface DeletePipelineOverlayData {
    pipelineId?: string | null;
    pipelineName?: string | null;
    source?: 'canvas' | 'pipeline-list' | null;
}

interface OverlayState {
    type: OverlayType;
    isOpen: boolean;
    data?: SchedulePipelineOverlayData | DeletePipelineOverlayData | null;
    returnTo?: OverlayType | null;
}

const initialState: OverlayState = {
    type: null,
    isOpen: false,
    data: null,
    returnTo: null,
};

const overlaySlice = createSlice({
    name: "overlay",
    initialState,
    reducers: {
        openOverlay: (
            state,
            action: PayloadAction<{
                type: OverlayType;
                data?: SchedulePipelineOverlayData | DeletePipelineOverlayData | null;
            }>
        ) => {
            state.isOpen = true;
            state.type = action.payload.type;
            state.data = action.payload.data || null;
        },
        closeOverlay: (state) => {
            state.isOpen = false;
            state.type = null;
            state.data = null;
        },
    },
});

export const { openOverlay, closeOverlay } = overlaySlice.actions;
export default overlaySlice.reducer;
